import script from "./AdminPluginManage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPluginManage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPluginManage.vue?vue&type=style&index=0&id=27dfd2ce&scoped=true&lang=css"
import "./AdminPluginManage.vue?vue&type=style&index=1&id=27dfd2ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27dfd2ce"]])

export default __exports__